import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/hammer-wrench.svg'


const _hoisted_1 = { class: "page-container" }
const _hoisted_2 = { class: "page-content" }
const _hoisted_3 = { class: "title" }

import PageHeader from "../components/ui/PageHeader.vue"
import { useDictionaryStore } from "@/store/dictionary"
import { storeToRefs } from "pinia"
import { computed } from "vue"
import { useI18n } from "vue-i18n"

export type Language = "en" | "hu"


export default /*@__PURE__*/_defineComponent({
  __name: 'MaintenancePage',
  setup(__props) {

const { locale } = useI18n()
const dictionaryStore = useDictionaryStore()
const { dynamicConfig } = storeToRefs(dictionaryStore)

const description = computed(() => {
  const lang = locale.value as Language
  return dynamicConfig?.value?.maintenanceMode.description?.[lang]
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeader),
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "icon-wrapper" }, [
        _createElementVNode("img", {
          class: "icon",
          src: _imports_0,
          alt: "maintenance"
        })
      ], -1)),
      _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("common.maintenanceMode.title")), 1),
      _createElementVNode("p", null, [
        _createElementVNode("strong", null, _toDisplayString(_ctx.$t("common.maintenanceMode.subTitle")), 1)
      ]),
      _createElementVNode("p", null, _toDisplayString(description.value), 1),
      _cache[1] || (_cache[1] = _createElementVNode("p", null, [
        _createElementVNode("a", { href: "mailto:fleet@mobiliti.hu" }, "fleet@mobiliti.hu")
      ], -1))
    ])
  ]))
}
}

})